export function populatedArrayOrUndefined<T>(array?: T[]) {
  if (array?.length) {
    return array;
  }
}
